/**
 * The standalone Partner Accounts pages (ID-13334 list, ID-13790 table, ID-13791 drawer, ID-13792
 * partner page), off the menu until they replace /partners. Pointing these at the original paths
 * is the switch-over.
 */
export const PARTNER_MANAGEMENT_PATH = '/partner-management';
